import React from "react";

import {
  Link,
} from "react-router-dom";

import {
  motion,
} from "framer-motion";

import {
  navItems,
} from "../../constants";

import {
  useStateContext,
} from "../../context/ContextProvider";


function Navebar({
  active,
  isScrolled,
}) {
  const {
    currentDir,
  } = useStateContext();


  return (
    <nav
      className="
        flex
        items-center

        gap-1
        xl:gap-2
      "
    >
      {navItems.map(
        (item, index) => {

          const isActive =
            active === index + 1;

          return (
            <Link
              key={item.id}
              to={item.link}
              onClick={() =>
                window.scrollTo({
                  top: 0,
                  behavior: "smooth",
                })
              }
            >
              <motion.div
                whileHover={{
                  y: -2,
                }}
                className={`
                  group

                  relative

                  flex
                  items-center
                  justify-center

                  px-3
                  xl:px-4

                  py-3

                  rounded-xl

                  overflow-hidden

                  font-kufi

             
                  xl:text-md

                  transition-all
                  duration-300

                  ${
                    isActive
                      ? `
                        text-color-1
                      `
                      : isScrolled
                      ? `
                        text-tcolor-4
                        dark:text-white/75

                        hover:text-color-1
                      `
                      : `
                        text-white/80

                        hover:text-white
                      `
                  }
                `}
              >

                {/* Active soft background */}

                {isActive && (
                  <motion.div
                    layoutId="yaman-navbar-active"
                    className={`
                      absolute
                      inset-0

                      rounded-xl

                      ${
                        isScrolled
                          ? `
                            bg-color-1/10
                          `
                          : `
                            bg-white/10
                          `
                      }
                    `}
                    transition={{
                      type: "spring",
                      bounce: 0.2,
                      duration: 0.55,
                    }}
                  />
                )}


                {/* Label */}

                <span
                  className="
                    relative
                    z-10

                    whitespace-nowrap
                  "
                >
                  {currentDir === "ltr"
                    ? item.titleEn
                    : item.titleAr}
                </span>


                {/* Active bottom line */}

                {isActive && (
                  <motion.span
                    layoutId="yaman-navbar-line"
                    className="
                      absolute
                      bottom-1

                      w-5
                      h-[2px]

                      rounded-full

                      bg-color-1
                    "
                  />
                )}


                {/* Hover line */}

                {!isActive && (
                  <span
                    className="
                      absolute
                      bottom-1

                      w-0
                      h-[2px]

                      rounded-full

                      bg-color-1

                      transition-all
                      duration-300

                      group-hover:w-4
                    "
                  />
                )}

              </motion.div>
            </Link>
          );
        }
      )}
    </nav>
  );
}

export default Navebar;